import type { SpeciesQuery } from "./api";

// One-shot handoff of a chosen location between the Plan tab and the Spot
// tab. When you view a plan for a place, it's stashed here; the next time
// the Spot page mounts it consumes and loads it, so Spot opens already
// populated with the spot you were just planning — no re-typing.
// Module-level (in-session) is enough; a reload legitimately starts fresh.
let pending: SpeciesQuery | null = null;

export function setActiveSpot(q: SpeciesQuery): void {
  pending = q;
}

// Read AND clear — the handoff is consumed once so returning to Spot later
// (without planning again) shows the normal picker.
export function takeActiveSpot(): SpeciesQuery | null {
  const q = pending;
  pending = null;
  return q;
}
